import script from "./BookingManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingManagement.vue?vue&type=script&setup=true&lang=js"

import "./BookingManagement.vue?vue&type=style&index=0&id=be1ae4f4&scoped=true&lang=css"
import "./BookingManagement.vue?vue&type=style&index=1&id=be1ae4f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be1ae4f4"]])

export default __exports__